import apiClient from '@/services/api/apiClient';

export default {
  getRoles: (payload) => apiClient.get('/roles/', { params: payload }),
  getRole: (id) => apiClient.get(`/roles/${id}/`),
  createRole: (payload) => apiClient.post('/roles/', payload),
  editRole: (payload) => apiClient.put(`/roles/${payload.id}/`, payload),
  deleteRole: (id) => apiClient.delete(`/roles/${id}/`),
};
